module.exports = __webpack_public_path__ + "site/img/contactzh.d11ec05c.png";